module.exports = __webpack_public_path__ + "media/images/new_home/video-btn-48ff5e847c1016bc8463619fb22e011c.png";